import { useCallback } from "react";

function formatPhone(digits: string): string {
  if (digits.length === 0) return "";
  let d = digits;
  if (d.startsWith("7") || d.startsWith("8")) {
    d = d.slice(1);
  }
  d = d.slice(0, 10);

  let result = "+7";
  if (d.length > 0) {
    result += " (" + d.slice(0, 3);
  }
  if (d.length >= 3) {
    result += ")";
  }
  if (d.length > 3) {
    result += " " + d.slice(3, 6);
  }
  if (d.length >= 6) {
    result += "-" + d.slice(6, 8);
  }
  if (d.length >= 8) {
    result += "-" + d.slice(8, 10);
  }
  return result;
}

function extractDigits(value: string): string {
  return value.replace(/\D/g, "");
}

export function usePhoneMask() {
  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    const digits = extractDigits(input.value);
    const formatted = formatPhone(digits);

    const prevFormatted = input.value;
    input.value = formatted;

    // Keep cursor at end when typing, or handle backspace intelligently
    const isAdding = formatted.length >= prevFormatted.length;
    if (isAdding) {
      input.setSelectionRange(formatted.length, formatted.length);
    } else {
      // When deleting, try to place cursor at logical position
      const cursor = Math.min(input.selectionStart || 0, formatted.length);
      input.setSelectionRange(cursor, cursor);
    }
  }, []);

  const onFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    if (!input.value) {
      input.value = "+7 (";
      input.setSelectionRange(4, 4);
    }
  }, []);

  const onBlur = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    const digits = extractDigits(input.value);
    // If only +7 or less than 2 digits total, clear the field
    if (digits.length <= 1) {
      input.value = "";
    }
  }, []);

  const onKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    // Prevent deleting the "+7 (" prefix with backspace
    if (e.key === "Backspace" && input.selectionStart !== null && input.selectionStart <= 4) {
      e.preventDefault();
    }
  }, []);

  return { onChange, onFocus, onBlur, onKeyDown };
}